/* istanbul ignore file */
import i18n from '../../i18n';
import { ProductFile } from './Uploader';

export type TenantUploadDBItem = {
  accountId: string;
  productName: string;
  description: string;
  productId: string;
  createdBy: string;
  created: number;
  filename: string;
  signedUrl: string;
  uploadId: string;
  size: number;
};

/**
 * Product files we get from the API (uploaded files)
 */
export type ProductFileData = Omit<ProductFile, 'file'> & { uploadId: string };

export function mapSrcToProductFile(uploadItem: TenantUploadDBItem): ProductFileData {
  return {
    name: uploadItem.filename,
    products: getProductData(uploadItem),
    description: uploadItem.description || '',
    createdBy: uploadItem.createdBy,
    createdAt: uploadItem.created,
    presignedUrl: { url: uploadItem.signedUrl, name: uploadItem.filename },
    // updatedAt - TODO: add updatedAt to uploadItem
    // updatedBy - TODO: add updatedBy to uploadItem
    size: uploadItem.size,
    uploadId: uploadItem.uploadId,
    // type: uploadItem.filetype as any,
  };
}

export function isTenantUploadDBItem(item: any): item is TenantUploadDBItem {
  return Boolean(
    item &&
      typeof item === 'object' &&
      item.accountId &&
      item.productName &&
      item.productId &&
      item.createdBy &&
      item.created &&
      item.signedUrl &&
      item.filename
  );
}

function getProductData(uploadItem: TenantUploadDBItem): ProductFileData['products'] {
  const formatName = (name: string) =>
    name === 'NO_PRODUCT' ? /* istanbul ignore next */ i18n.t('status.error.noProduct') : name;
  const { productId, productName } = uploadItem;
  return [{ productId: formatName(productId), name: formatName(productName) }];
}
